import { DatePicker, DatePickerProps, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

export const FE_DATE_FORMAT = "DD/MM/YYYY";
export const BE_DATE_FORMAT = "YYYY-MM-DD";

export default function ShireDatePicker(props: DatePickerProps<any>) {
  return <LocalizationProvider dateAdapter={AdapterDayjs}>
  <DatePicker
    {...props}
    format={FE_DATE_FORMAT}
    slotProps={{
      textField: {
        sx: {
          width: '100%',
          backgroundColor: 'white',
        },
      },
    }}
  />
  </LocalizationProvider>
}